export default {
  namespaced: true,
  state: {
    isCollapsed: false
  },
  mutations: {
    SET_COLLAPSED(state, value) {
      state.isCollapsed = value;
    },
    TOGGLE_COLLAPSED(state) {
      state.isCollapsed = !state.isCollapsed;
    }
  },
  actions: {
    setCollapsed({ commit }, value) {
      commit('SET_COLLAPSED', value);
    },
    toggleCollapsed({ commit }) {
      commit('TOGGLE_COLLAPSED');
    }
  },
  getters: {
    isCollapsed: state => state.isCollapsed
  }
};
